import React from 'react'
import TableCompareRow from './TableCompareRow'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'

const TableCompare = ({ changes, action }) => (
  <TableContainer>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Fields</TableCell>
          <TableCell>Old value</TableCell>
          <TableCell>New value</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {changes?.fields?.length > 0 && changes?.fields?.map((field, index) => 
          <TableCompareRow 
            key={`table-row-${field}-${index}`}
            index={index}
            field={field}
            oldValues={changes?.oldValues || {}}
            newValues={changes?.newValues || {}}
            action={action}
          />
        )}
        {changes?.fields?.length === 0 && <div>You don't have any changes yet</div>}
      </TableBody>
    </Table>
  </TableContainer>
)
export default TableCompare